export const GITBOOK_DOCS_QUERY_KEY = "GITBOOK_DOCS_QUERY_KEY";

export const DocsQueryKeys = {
  gitbookDocs: (spaceId: string, path: string) => [
    GITBOOK_DOCS_QUERY_KEY,
    spaceId,
    path,
  ],
};
